export const LOGO_URL =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_2269a8a9-4afd-4e3c-8f5e-1c52b9ed80e9/artifacts/uebxjxcv_Straight%201%20%282%29.webp";

export const EASE = [0.22, 1, 0.36, 1];

export const PRODUCTS = [
  {
    key: "consumer",
    title: "Consumer Cards",
    badge: "100% On-Chain Native",
    blurb:
      "Connect your Web3 wallet and spend directly from self-custody.",
    steps: [
      "Connect wallet",
      "Tap Straight card",
      "Approve payment",
      "Funds move on-chain",
      "Merchant gets paid",
    ],
  },
  {
    key: "enterprise",
    title: "Enterprise Cards",
    badge: "Visa & Mastercard Compatible",
    blurb:
      "Launch crypto cards using existing Visa & Mastercard infrastructure.",
    steps: [
      "Connect customer wallet",
      "Customer taps card",
      "Straight authorizes payment",
      "Stablecoins move to issuer",
      "Merchant gets paid",
    ],
  },
];

export const CONSUMER_STEPS = [
  {
    title: "Get Straight Card in seconds",
    desc: "Order and activate your Straight Card instantly — no paperwork, no waiting.",
  },
  {
    title: "Connect it to your wallet",
    desc: "Link the card to the self-custody wallet you already use.",
  },
  {
    title: "Spend at on-chain POS",
    desc: "You're all set to pay directly at any on-chain point of sale.",
  },
];

export const BUSINESS_CAPABILITIES = [
  "Wallet connectivity",
  "Payment authorization",
  "Stablecoin settlement",
  "Transaction reconciliation",
  "Spending controls",
  "Multi-chain support",
  "Developer APIs",
];

export const WHY = [
  {
    title: "Self-custody first",
    desc: "Your assets stay in your wallet.",
    span: "md:col-span-2",
  },
  {
    title: "No top-ups",
    desc: "Spend directly from your balance.",
    span: "md:col-span-1",
  },
  {
    title: "Instant payments",
    desc: "Real-time authorization and settlement.",
    span: "md:col-span-1",
  },
  {
    title: "Spend anywhere",
    desc: "Compatible with global card networks.",
    span: "md:col-span-2",
  },
  {
    title: "Stablecoin native",
    desc: "Built for USDC, USDT, and programmable money.",
    span: "md:col-span-2",
  },
  {
    title: "Enterprise ready",
    desc: "APIs for banks, fintechs, and issuers.",
    span: "md:col-span-1",
  },
];

export const ECOSYSTEM = [
  { name: "Bexo", role: "Self-custody wallet" },
  { name: "ActaPay", role: "Merchant acceptance" },
  { name: "Straight", role: "Card network", active: true },
  { name: "OpenDeposit", role: "Wallet & account transfers" },
];
